import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';

@Component({
  selector: 'rma-add-agent-slot',
  templateUrl: './add-agent-slot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(COMPARE_AGENT_SCOPE)],
  imports: [RmaIconComponent, RouterLink, TranslocoDirective],
  host: {
    class: 'block h-full',
  },
})
export class AddAgentSlotComponent {
  protected readonly scope = COMPARE_AGENT_SCOPE;
}
